/*
  CUSTOM:have-questions-ask
  Makes the product page's "Have Questions?" link (the <a data-custom-have-questions> in
  sections/main-product.liquid) scroll to the Customer Reviews and open Judge.me's own
  "Ask a question" form. The form, the submit and the public Q&A list stay Judge.me's: the theme
  builds no form of its own. Loaded from layout/theme.liquid only while Theme settings → Product
  page (custom) → "Have Questions? opens the Ask a question form" is on. Same file as kiichin-theme's
  assets/custom-have-questions-ask.js, but the link is picked by its data attribute here, because
  this theme's link is a hardcoded <a> and not the .custom-have-questions paragraph.

  Fallbacks, so the link never becomes a dead end:
  - no review widget on the page: nothing here runs, the link follows its own URL (contact page);
  - widget present but Questions & Answers is off in the Judge.me dashboard (no Ask a question
    button): the page scrolls to the reviews and stops there.

  The selectors are Judge.me's legacy review widget, read from the app's own script
  (cdnwidget.judge.me/shopify_v2.js, 2026-09-25):
  - .jdgm-review-widget          the widget root (id judgeme_product_reviews)
  - .jdgm-ask-question-btn       added by jdgm.renderAskQuestionBtn() when "enable_question_anwser"
                                 is on in the dashboard
  - .jdgm-question-form-wrapper  the form; clicking the button toggles it, so click only while it
                                 is hidden
  If Judge.me changes that markup (for example the "revamp" widget), the link degrades to a scroll
  to the reviews and nothing breaks.
*/
(() => {
  if (window.customHaveQuestionsAsk) return;
  window.customHaveQuestionsAsk = true;

  const WIDGET = '.jdgm-review-widget';
  const ASK_BUTTON = '.jdgm-ask-question-btn';
  const FORM = '.jdgm-question-form-wrapper';
  // Judge.me builds the button after its script loads; give it time on slow networks.
  const WAIT_MS = 10000;

  const isVisible = (element) => !!element && element.getClientRects().length > 0;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-custom-have-questions]');
    if (!trigger) return;

    const widget = document.querySelector(WIDGET);
    if (!widget) return; // no review widget on this page: let the link go where it points

    event.preventDefault();
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Judge.me loads its form code lazily: until then the first click on its button only starts
    // that load and the form wrapper does not exist yet. So click once to start the load, then
    // click again once the form exists.
    let loadStarted = false;
    const openForm = () => {
      const button = widget.querySelector(ASK_BUTTON);
      if (!button) return false;
      const form = widget.querySelector(FORM);
      if (!form) {
        if (!loadStarted) {
          loadStarted = true;
          button.click();
        }
        return false;
      }
      if (!isVisible(form)) button.click();
      return true;
    };

    if (openForm()) return;

    const stop = () => {
      observer.disconnect();
      clearTimeout(timer);
    };
    const observer = new MutationObserver(() => {
      if (openForm()) stop();
    });
    const timer = setTimeout(stop, WAIT_MS);
    observer.observe(widget, { childList: true, subtree: true });
  });
})();
